<template>
    <el-drawer class="w-el-drawer" :visible.sync="visible" :size="650" :with-header="false" direction="rtl" :before-close="Close" append-to-body>
        <div class="w-el-drawer-header">
            <i class="el-icon-tickets"></i> 编辑回款计划
        </div>
        <div class="w-el-drawer-body"  v-loading="loading">
            <el-form :model="form" label-width="120px" size="mini">
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="关联合同" :error="formError.contract_id?.toString()" prop="contract_id">
                    <crm-contract-select v-model="form.contract_id" @onChange="ContractOnChange" />
                </el-form-item>
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="关联客户" :error="formError.customer_id?.toString()" prop="customer_id">
                    <crm-customer-select v-model="form.customer_id" clearable />
                </el-form-item>
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="计划回款日期" :error="formError.pay_date_plan?.toString()" prop="pay_date_plan">
                    <el-date-picker v-model="form.pay_date_plan" value-format="yyyy-MM-dd" type="date" placeholder="请选择计划回款日期" clearable />
                </el-form-item>
                <el-form-item :rules="[{ required: true, message: '必选项' }]" label="回款负责人" :error="formError.user_id?.toString()" prop="user_id">
                    <users-select v-model="form.user_id" />
                </el-form-item>
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="回款金额" :error="formError.pay_money?.toString()" prop="pay_money">
                    <el-input-number v-model="form.pay_money" :min="0" :precision="2" label="回款金额" style="width: 35%;" @change="form.pay_money_offset = form.pay_money"></el-input-number>
                </el-form-item>
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="冲销金额" :error="formError.pay_money_offset?.toString()" prop="pay_money_offset">
                    <el-input-number v-model="form.pay_money_offset" :min="0" :precision="2" label="冲销金额" style="width: 35%;"></el-input-number>
                </el-form-item>
                <el-form-item label="开具发票">
                    <el-checkbox v-model="form.invoice_state">需要开具发票</el-checkbox>
                </el-form-item>
                <el-form-item label="回款计划描述">
                    <el-input v-model="form.describe" type="textarea" :rows="5" placeholder="回款计划描述"></el-input>
                </el-form-item>
            </el-form>
            <template v-if="contract.files_id && contract.files_id.length > 0">
                <el-divider content-position="left">合同附件</el-divider>
                <files-table v-model="contract.files_id" :span="24" preview-type="drawer" preview-direction="ltr" :preview-modal="false" :drawer-size="drawerSize" />
            </template>
        </div>
        <div class="w-el-drawer-footer">
            <el-button size="mini" @click="Close()">取消 / 返回</el-button>
            <el-button size="mini" type="primary" @click="FormSubmit()" :loading="loading">修改回款计划</el-button>
        </div>
    </el-drawer>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            loading: false,
            drawerSize: '80%',
            formError: {},
            form: {
                id: null,
                contract_id: null,
                customer_id: null,
                pay_date_plan: null,
                user_id: null,
                pay_money: 0,
                pay_money_offset: 0,
                invoice_state: true,
                describe: null,
            },
            contract: {
                files_id: []
            },
        }
    },
    mounted() {
        this.ListenerResizeFn()
        window.addEventListener('resize', this.ListenerResizeFn)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.ListenerResizeFn)
    },
    methods: {
        ListenerResizeFn() {
            this.drawerSize = window.innerWidth - 650
        },
        Open(id) {
                        this.visible = true
            this.loading = true
            this.$http.post('/9api/contract-pay-plan/first', { id: id }).then(rps => {
                this.form.id = rps.data.id
                this.form.contract_id = rps.data.contract_id
                this.form.customer_id = rps.data.customer_id
                this.form.user_id = rps.data.user_id
                this.form.pay_date_plan = rps.data.pay_date_plan
                this.form.pay_money = rps.data.pay_money
                this.form.pay_money_offset = rps.data.pay_money_offset
                this.form.invoice_state = rps.data.invoice_state == 2 ? false : true
                this.form.describe = rps.data.describe
                this.loading = false
            })
        },
        Close() {
            this.formError = {}
            this.form.id = null
            this.form.contract_id = null
            this.form.customer_id = null
            this.form.pay_date_plan = null
            this.form.user_id = null
            this.form.pay_money = 0
            this.form.pay_money_offset = 0
            this.form.invoice_state = true
            this.form.describe = null
            this.contract.files_id = []
            this.visible = false
            this.loading = false
        },
        ContractOnChange(data) {
            this.contract.files_id = data?.files_id
            this.form.customer_id = data?.customer_id
        },
        FormSubmit() {
                        this.loading = true
            this.formError = {}
            this.$http.post('/9api/contract-pay-plan/edit', this.form).then(rps => {
                this.loading = false
                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }
                if (rps.data.state == 'success') {
                    this.$notify.success({
                        title: '提示',
                        message: '回款计划修改成功',
                        duration: 2000
                    })
                    this.$emit("success")
                    this.Close()
                }
            })
        }
    }
}
</script>